import {useMediaQuery} from '@mui/material'
import {FC, ReactElement} from 'react'
import {RegisterButton} from 'features/buttons'
import {Diamond, Explorer, Heart, LetsEncrypt, Norton, PCICertificate, Ring, SiteJabber, TrustPilot} from './icons/icons'
import styles from './styles.module.scss'

export const UsefulSection: FC = () => {
  const isMobile = useMediaQuery(`(max-width: ${styles.isMobile})`)

  return (
    <>
      <div className={styles.container}>
        <h2 className={styles.title}>
          Our <span className={styles.highlight}>website</span> is useful <span className={styles.highlight}>for</span>
        </h2>
        <div className={styles.usefulContainer}>
          <UsefulComponent
            icon={<Ring />}
            title='Singles who wants to find love'
            description='Discover the perfect match even if you are thousands of miles apart'
          />
          <UsefulComponent
            icon={<Diamond />}
            title='Exclusive & premium content lovers'
            description='Here you will find content and emotions that are not available on other Social Networks'
          />
        </div>
        <div className={styles.usefulContainer}>
          <UsefulComponent
            icon={<Heart />}
            title='Lonely people who search companions'
            description='We help to find soulemates with common interests and values'
          />
          <UsefulComponent
            icon={<Explorer />}
            title='Explorers'
            description='We allow you to explore different experiences and yourself, finding for what fits you best'
          />
        </div>
        <RegisterButton className={styles.btn} styleType='primary'>Ready to explore?</RegisterButton>
        <div className={styles.certificateContainer}>
          <p className={styles.certificateTitle}>Secured & trusted communication platform</p>
          {isMobile ? <CertificateBlockMobile /> : <CertificateBlock />}
        </div>
      </div>
    </>
  )
}


type UsefulComponentProps = {
  icon: ReactElement,
  title: string,
  description: string
}
const UsefulComponent: React.FC<UsefulComponentProps> = ({icon, title, description}) => {
  return (
    <div className={styles.useful}>
      <div className={styles.useful__icon}>{icon}</div>
      <p className={styles.useful__title}>{title}</p>
      <p className={styles.useful__description}>{description}</p>
    </div>
  )
}

const CertificateBlock: FC = () =>
  <div className={styles.certificateWrapper}>
    <div className={styles.largeIcon}> <Norton /></div>
    <div className={styles.mediumIcon}><TrustPilot /></div>
    <div className={styles.largeIcon}><LetsEncrypt /></div>
    <div className={styles.mediumIcon}><SiteJabber /></div>
    <div className={`${styles.largeIcon} ${styles.lastSVG}`}><PCICertificate /></div>
  </div>

const CertificateBlockMobile: FC = () =>
  <div className={styles.certificateInner}>
    <div className={styles.certificateOuter}>
      <CertificateBlock />
      <CertificateBlock />
    </div>
  </div>